import Breadcrumb from '@/components/app/breadcrumb';
<template>
  <v-container class="d-flex align-center pa-0">
    <CToggler
            in-header
            class="ml-3 d-lg-none"
            @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
            in-header
            class="ml-3 d-md-down-none"
            @click="$store.commit('toggleSidebarDesktop')"
    />
    <v-breadcrumbs :items="items" class="px-4  py-0">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :class="$style['breadcrumbs-item']" color="#000" href="" @click.stop="move(item.to)"
                            :disabled="item.disabled">
          <fragment v-if="item.disabled">
          {{ item.text }}
          </fragment>
          <fragment v-else>
            <a>{{ item.text }}</a>
          </fragment>
        </v-breadcrumbs-item>
      </template>
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </v-container>
</template>

<script>
import { routes } from "@/router";

export default {
  props: {
    items: {
      type: Array
    }
  },
  data: () => ({}),
  computed: {
    currentPath() {
      return this.$router.history.current.matched[1].path.substr(1);
    },
    currentRealPath() {
      return this.$router.history.current.fullPath;
    },
    parentPath() {
      return (this.$router.history.current.path.substr(1).split("/") || [])[0];
    }
  },
  methods: {
    createBreadcrumbs() {
      return routes.reduce((prev, curr) => {
        if (curr.path === this.parentPath) {
          prev.push({
            text: (curr.meta || {}).title || "",
            disabled: this.parentPath === this.currentPath,
            to: `/${this.parentPath}`
          });
        }

        if (
          this.parentPath !== this.currentPath &&
          curr.path === this.currentPath
        ) {
          prev.push({
            text: (curr.meta || {}).title || "",
            disabled: curr.path === this.currentPath,
            to: this.currentRealPath
          });
        }

        return prev;
      }, []);
    },
    move(to){
      console.log(to);
      this.$router.push({ path: to });
    }
  },
  mounted() {
    // this.items = this.createBreadcrumbs();
  }
};
</script>

<style module lang="scss">
.breadcrumbs-item {
  & > div > a {
    color: #999 !important;
    font-weight: bold;
  }
  & > div {
    color: #000 !important;
    max-width: 400px;
    //min-width: 120px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}
</style>

<style scope lang="scss">
.v-breadcrumbs__divider {
  & > i {
    font-size: 20px !important;
    &:before {
      font-weight: bold;
    }
  }
}
</style>
